import { VantageNames } from '@/vantage/constants';
import type { ContextCharacteristic, ExtensionSchema } from '@/vantage/types/Extension.types';

/** Notes stays active when disabled because every submitted context is wrapped in a note; disabling only blocks typing one. */
export const isActiveExtension = ({ name, enabled }: ExtensionSchema) =>
  Boolean(enabled) || name === VantageNames.Extensions.Notes;

export const isNotesEnabled = (extensions: ExtensionSchema[]) =>
  extensions.find((ext) => ext.name === VantageNames.Extensions.Notes)?.enabled ?? true;

export function addCharacteristicsForPurviewFields(
  extension: ExtensionSchema,
  purviewFields: string[],
): ExtensionSchema {
  const template = extension.contextCharacteristics?.[0];
  const existingKinds = extension.contextCharacteristics?.map((c) => c.kind) ?? [];
  const newPurviewFields: ContextCharacteristic[] =
    purviewFields
      ?.filter((field) => !existingKinds.includes(field))
      ?.map((field) => ({ ...template, kind: field, eventTimeRepresentation: undefined })) ?? [];

  return {
    ...extension,
    contextCharacteristics:
      newPurviewFields.length > 0
        ? extension.contextCharacteristics?.concat(newPurviewFields)
        : extension.contextCharacteristics,
  };
}
